import { creatorbase } from '@round/api';
import { getTableMetaHelper, Skeleton } from '@round/ui-kit';
import { HeaderContext } from '@tanstack/react-table';
import { formatPostStatsCellValue } from 'Modules/Plans/Posts/helpers';
import { BasePostTableMeta, PostsTotalsNumericField } from 'Modules/Plans/Posts/types';

type Row = creatorbase.PublicPost;

type Props<T extends Row> = HeaderContext<T, number | null | undefined> & {
    totalsField?: PostsTotalsNumericField;
};

const getTableMeta = getTableMetaHelper<BasePostTableMeta<Row>>();

/**
 * [!] This component requires a valid accessorFn or accessorKey to be declared on the columnDef.
 */
const PostStatsFooterTotalCell = <T extends Row>({ table, column, totalsField }: Props<T>) => {
    const { isLoading, areApiTotalsEnabled, postsTotals, areTotalsLoading } = getTableMeta(table);

    if (areApiTotalsEnabled) {
        if (areTotalsLoading) {
            return <Skeleton />;
        }

        if (!postsTotals || !totalsField) {
            return '-';
        }

        return formatPostStatsCellValue(postsTotals[totalsField] ?? 0);
    }

    if (isLoading) {
        return <Skeleton />;
    }

    const total = table.getRowModel().rows.reduce((acc, row) => {
        const value: number | undefined = row.getValue(column.id) || undefined;
        return typeof value === 'number' ? acc + value : acc;
    }, 0);

    return formatPostStatsCellValue(total);
};

export default PostStatsFooterTotalCell;
